// react-select style objects shared by App.js and the search / vibe panels.
// Everything is driven by the App.css tokens, so both themes work without
// theme-specific rules.

export const selectStyles = {
  control: (base, state) => ({
    ...base,
    background: 'var(--fill-control)',
    borderColor: state.isFocused ? 'var(--accent)' : 'transparent',
    boxShadow: state.isFocused ? '0 0 0 3px var(--accent-ring)' : 'none',
    borderRadius: 10,
    minHeight: 36,
    cursor: 'pointer',
    ':hover': { borderColor: state.isFocused ? 'var(--accent)' : 'var(--separator)' },
  }),
  valueContainer: (base) => ({ ...base, padding: '0 6px 0 12px' }),
  singleValue: (base) => ({ ...base, color: 'var(--text-1)', fontWeight: 600, fontSize: 13 }),
  input: (base) => ({ ...base, color: 'var(--text-1)', fontSize: 13 }),
  placeholder: (base) => ({ ...base, color: 'var(--text-3)', fontSize: 13 }),
  menu: (base) => ({
    ...base,
    zIndex: 1000,
    background: 'var(--bg-menu)',
    borderRadius: 12,
    overflow: 'hidden',
    boxShadow: '0 12px 40px rgba(0,0,0,0.45), 0 0 0 0.5px var(--separator)',
    backdropFilter: 'blur(20px)',
  }),
  menuList: (base) => ({ ...base, padding: 6 }),
  option: (base, state) => ({
    ...base,
    fontSize: 13,
    borderRadius: 8,
    cursor: 'pointer',
    color: state.isSelected ? '#fff' : 'var(--text-1)',
    background: state.isSelected ? 'var(--accent)' : state.isFocused ? 'var(--fill-hover)' : 'transparent',
    ':active': { background: 'var(--accent)' },
  }),
  indicatorSeparator: () => ({ display: 'none' }),
  dropdownIndicator: (base) => ({ ...base, color: 'var(--text-3)', padding: '0 8px 0 0' }),
  noOptionsMessage: (base) => ({ ...base, fontSize: 13, color: 'var(--text-3)' }),
};

// isMulti variant (SongChipInput and friends): same control and menu, plus
// chip styling for the selected values.
export const selectStylesMulti = {
  ...selectStyles,
  valueContainer: (base) => ({ ...base, padding: '3px 6px 3px 8px' }),
  multiValue: (base) => ({
    ...base,
    background: 'var(--accent-soft)',
    borderRadius: 8,
    margin: 2,
    alignItems: 'center',
  }),
  multiValueLabel: (base) => ({
    ...base,
    color: 'var(--text-1)',
    fontSize: 12,
    fontWeight: 600,
    // react-select's base sets padding and paddingLeft; override both
    padding: '3px 4px',
    paddingLeft: 8,
  }),
  multiValueRemove: (base) => ({
    ...base,
    color: 'var(--text-2)',
    borderRadius: '0 8px 8px 0',
    cursor: 'pointer',
    ':hover': { background: 'var(--fill-hover)', color: 'var(--text-1)' },
  }),
  clearIndicator: (base) => ({ ...base, color: 'var(--text-3)', padding: '0 4px', ':hover': { color: 'var(--text-1)' } }),
};
